import React from 'react'
import { Button, useRecordContext, useTranslate } from 'react-admin'
import { Link, useLocation } from 'react-router-dom'

export const DetailVersionButton = () => {
  const record = useRecordContext()
  const translate = useTranslate()
  const location = useLocation()
  if (!record) return null

  return (
    <Button
      component={Link}
      to={`${location.pathname}/${record.version}/show`}
      label={translate('ra.action.see_details')}
      onClick={(e) => e.stopPropagation()}
      title={translate('ra.action.see_details')}
    />
  )
}
